import React from 'react';
import ArchiveItem from '../../components/ArchiveItem';
import './index.css';

const Archive = () => {
  const archiveData = [
    {
      year: "2025年12月",
      posts: [
        { title: "恒星:宇宙的主角", date: "2025-12-8", tags: ["大二", "校园"] },
        { title: "两颗恒星的十万年", date: "2025-12-19", tags: ["美食", "武汉", "攻略"] }
      ]
    }
  ];

  return (
    <div className="archive">
      <h2><span className="purple-star">★</span> 文章归档</h2>
      {archiveData.map((section, idx) => (
        <div key={idx} className="archive-section">
          <h3>{section.year}</h3>
          <div className="posts-list">
            {section.posts.map((post, pIdx) => (
              <ArchiveItem key={pIdx} {...post} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Archive;